import React, { lazy, Suspense } from "react";
import { useInView } from "react-intersection-observer";

const BlogComponent = lazy(() => import("../../components/home/blog.component"));

const LazyBlog = ({ newsForCategories }: any) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });


  return (
    <div ref={ref}>
      {inView ? (
        <Suspense fallback={<div>Cargando Portafolio...</div>}>
          <BlogComponent newsForCategories={newsForCategories} />
        </Suspense>
      ) : (
        <div>Cargando Blogs...</div>
      )}
    </div>
  );
};

export default LazyBlog;
